// @ts-ignore
import Quill from '@cimpress-technology/quill/core';

export const { StyleAttributor, Scope } = Quill.import('parchment');

class LineHeightAttributor extends StyleAttributor {
    public add(node: HTMLElement, value: string) {
        // Rendering doesn't currently support line height on list items, so we exclude lineHeight from <li> tags to keep the editor in sync with previews
        // TODO: Remove the `node.tagName === 'LI'` if/when rendering supports lineHeight on text lists
        if (!super.canAdd(node, value) || node.tagName === 'LI') {
            return false;
        }
        // eslint-disable-next-line no-param-reassign
        node.dataset.lineHeight = value;

        return super.add(node, value);
    }

    public remove(node: HTMLElement): boolean {
        // eslint-disable-next-line no-param-reassign
        delete node.dataset.lineHeight;
        return super.remove(node);
    }

    // eslint-disable-next-line class-methods-use-this
    public value(node: HTMLElement): any {
        if (!node.dataset.lineHeight) {
            return '';
        }
        return node.dataset.lineHeight;
    }
}

// @ts-ignore
export default new LineHeightAttributor('lineHeight', 'line-height', {
    scope: Scope.INLINE,
});
// @ts-ignore
export const BlockLineHeightAttributor = new LineHeightAttributor('blockLineHeight', 'line-height', { scope: Scope.BLOCK });
